<template>
    <!-- Familienversicherung (ARNF - tarif8) -->
    <div class="versicherungs-button" role="button" tabindex="0" @click="$emit('select')" @keydown.enter="$emit('select')" @keydown.space.prevent="$emit('select')">
        <input type="checkbox" id="familienversicherung" class="d-none" :checked="selected">
        <label 
            class="d-flex flex-column p-3 border rounded w-100" 
            data-type="familienversicherung"
            :class="{ 'selected': selected }"
        >
            <div class="d-flex justify-content-between align-items-center">
                <familienversicherung_icon></familienversicherung_icon>
                <h1>{{ beitragStr }}</h1>
            </div>
            <h3 class="mt-2">Familienversicherung</h3>
        </label>
    </div>
</template>

<script setup>
import familienversicherung_icon from "@/components/icons/familienversicherung_icon.vue";

defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    beitragStr: {
        type: String,
        default: 'ab 46,80 €'
    }
});

defineEmits(['select']);
</script>

<style scoped>
/* Selected State Styling */
label.selected {
    background-color: var(--vigo-1-500-bg) !important;
}

label.selected h1,
label.selected h3 {
    color: var(--vigo-hell-text) !important;
}

label.selected :deep(svg path) {
    fill: var(--vigo-hell-bg) !important;
}
</style>
